
const ContractDetails = ({
  cartingDetails,
  agentDetails,
  agentAddress,
  procurement,
  formatProcurement,
  alignRight = true, 
  className = '', 
}) => {
  if (!cartingDetails && !agentDetails && !agentAddress && !procurement) return null;

  const alignmentClass = alignRight ? 'has-text-right' : '';

  return (
    <div className={`columns is-variable is-1 mt-3 ${className}`}>
      {procurement?.length > 0 && (
        <div className={`column is-3 ${alignmentClass}`}>
          <strong>Procurement:</strong> {formatProcurement ? formatProcurement(procurement) : procurement}
        </div>
      )}

      {cartingDetails?.length > 0 && (
        <div className={`column is-3 ${alignmentClass}`}>
          <strong>Carting Details:</strong> {cartingDetails}
        </div>
      )}

      {agentDetails?.length > 0 && (
        <div className={`column is-3 ${alignmentClass}`}>
          <strong>Agent Details:</strong> {agentDetails}
        </div>
      )}

      {agentAddress?.length > 0 && (
        <div className={`column is-3 ${alignmentClass}`} style={{ whiteSpace: 'pre-line' }}>
          <strong>Agent Address:</strong>{" "}
          <span>{agentAddress}</span>
        </div>
      )}
    </div>
  );
};

export default ContractDetails;
